"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = Card;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = __importDefault(require("react"));
const Theme_1 = require("../Theme");
const react_native_1 = require("react-native");
const react_native_fontawesome_1 = require("@fortawesome/react-native-fontawesome");
const react_i18next_1 = require("react-i18next");
const ThemeContext_1 = require("../ThemeContext");
const ResponsiveContext_1 = require("../contexts/ResponsiveContext");
const useStyles = () => {
    const THEME = (0, ThemeContext_1.useTheme)();
    const { size, columns } = (0, ResponsiveContext_1.useResponsiveContext)();
    return react_native_1.StyleSheet.create({
        container: {
            backgroundColor: THEME.CardBackground,
            borderColor: columns > 1 ? THEME.CardBorder : null,
            borderRadius: columns > 1 ? 4 : null,
            borderWidth: columns > 1 ? 1 : null,
            borderBottomWidth: columns > 1 ? 2 : null,
            padding: 12,
            paddingBottom: 6,
            overflow: 'hidden'
        },
        header: {
            borderColor: '#e8e8e8',
            borderBottomWidth: 1,
            flexDirection: 'row',
            padding: 10,
            paddingHorizontal: 12
        },
        headerText: {
            color: THEME.Text,
            fontSize: size != 'sm' ? 18 : 16
        }
    });
};
function Card(props) {
    const { size, columns } = (0, ResponsiveContext_1.useResponsiveContext)();
    const { t } = (0, react_i18next_1.useTranslation)();
    const THEME = (0, ThemeContext_1.useTheme)();
    const styles = useStyles();
    const STYLES = (0, Theme_1.useGlobalStyles)();
    return ((0, jsx_runtime_1.jsxs)(react_native_1.View, { style: [styles.container, columns > 1 ? STYLES.cardLandscape : STYLES.cardPortait, props.style], children: [props.headerButton &&
                (0, jsx_runtime_1.jsx)(react_native_1.Pressable, { accessible: true, "aria-label": props.headerText, accessibilityHint: props.headerAccessibilityHint ?? '', onPress: props.headerPress, style: ({ pressed }) => [
                        pressed ? { opacity: 0.5 } : null
                    ], children: (0, jsx_runtime_1.jsxs)(react_native_1.View, { style: styles.header, children: [(0, jsx_runtime_1.jsx)(react_native_1.View, { style: { flex: 3, justifyContent: 'center' }, children: (0, jsx_runtime_1.jsxs)(react_native_1.View, { style: { flexDirection: 'row', alignItems: 'center' }, children: [(0, jsx_runtime_1.jsx)(react_native_1.View, { style: {
                                                backgroundColor: '#686f8e',
                                                borderRadius: 4,
                                                padding: 6
                                            }, children: (0, jsx_runtime_1.jsx)(react_native_fontawesome_1.FontAwesomeIcon, { icon: props.headerIcon, size: size != 'sm' ? 20 : 18, color: THEME.AlwaysWhite }) }), (0, jsx_runtime_1.jsx)(react_native_1.Text, { accessible: false, style: {
                                                marginLeft: 10, color: THEME.Text,
                                                fontSize: (size != 'sm' ? 20 : 18), fontWeight: '500'
                                            }, children: props.headerText })] }) }), (0, jsx_runtime_1.jsx)(react_native_1.View, { style: { alignSelf: 'flex-end' }, children: size != 'sm'
                                    &&
                                        (0, jsx_runtime_1.jsxs)(react_native_1.View, { style: {
                                                marginVertical: 4, marginHorizontal: 2,
                                                flexDirection: 'row', alignItems: 'center',
                                                borderColor: THEME.PrimaryDark, borderWidth: 1, borderRadius: 3,
                                                paddingVertical: 8, paddingHorizontal: 16
                                            }, children: [(0, jsx_runtime_1.jsx)(react_native_1.Text, { style: { color: THEME.PrimaryDark, fontSize: 16, fontWeight: '500', marginRight: 8, marginTop: -2 }, children: props.headerActionText ?? t('common:buttons.view') }), (0, jsx_runtime_1.jsx)(react_native_fontawesome_1.FontAwesomeIcon, { icon: props.headerActionIcon ?? Theme_1.ICONS.Solid.ArrowRight, size: size != 'sm' ? 18 : 24, color: THEME.PrimaryDark })] })
                                    ||
                                        (0, jsx_runtime_1.jsx)(react_native_1.View, { style: { borderRadius: 4, padding: 6 }, children: (0, jsx_runtime_1.jsx)(react_native_fontawesome_1.FontAwesomeIcon, { icon: props.headerActionIcon ?? Theme_1.ICONS.Regular.ChevronRight, size: size != 'sm' ? 18 : 20, color: THEME.Text }) }) })] }) }), props.header &&
                (0, jsx_runtime_1.jsxs)(react_native_1.View, { style: styles.header, children: [(0, jsx_runtime_1.jsx)(react_native_1.View, { style: { flex: 3, justifyContent: 'center' }, children: (0, jsx_runtime_1.jsx)(react_native_1.Text, { style: styles.headerText, children: props.header }) }), (0, jsx_runtime_1.jsx)(react_native_1.View, { style: { alignSelf: 'flex-end' }, children: props.headerAction })] }), (0, jsx_runtime_1.jsx)(react_native_1.View, { style: { flex: 1 }, children: props.children })] }));
}
